import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import Form from 'components/Form';
import App from 'modules/App';
import { SET_PASSWORD_FORM } from '../../constants';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import messages from '../../messages';
import Validator from '../../AccountValidator';
import Password from '../Password';
import Actions from './Actions';
import validatorRules from './validatorRules.json';
const SetPassword = ({ email, isOneLiner = false })=>{
    const hasErrors = useSelector(selectors.hasSetNewPasswordErrors);
    const formValues = useSelector(App.selectors.formSelector(SET_PASSWORD_FORM));
    const initSetPassword = useAction(actions.setNewPassword);
    const setPassword = useAction(actions.setPassword);
    const clearVerifiedSignatureToken = useAction(actions.setVerifiedSignatureToken, null);
    const clearForm = useAction(App.actions.clearForm, SET_PASSWORD_FORM);
    useEffect(()=>{
        initSetPassword(email);
        return ()=>{
            clearVerifiedSignatureToken();
            clearForm();
        };
    }, []);
    useEffect(()=>{
        if (hasErrors) initSetPassword(email);
    }, [
        hasErrors
    ]);
    const processForm = App.hooks.useFormProcessing(SET_PASSWORD_FORM, setPassword, {
        stopOnFirstError: false,
        Validator
    });
    const onValidatedSetFormValue = App.hooks.useValidatedSetFormValue(SET_PASSWORD_FORM, validatorRules, {
        stopOnFirstError: false,
        Validator
    });
    const onSubmit = ()=>{
        processForm(formValues, validatorRules);
    };
    return /*#__PURE__*/ _jsxs(Form, {
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(Password, {
                    id: "password",
                    labelMessage: messages.labels.createPassword,
                    formValues: formValues,
                    isOneLiner: isOneLiner,
                    onChange: onValidatedSetFormValue
                })
            }),
            /*#__PURE__*/ _jsx(Actions, {
                isOneLiner: isOneLiner
            })
        ]
    });
};
export default SetPassword;
